export * from './pages';
export * from './homePage';
export * from './login/methodPage';
